import resume from '../assets/pdf/William_McCoy_Resume_5726.pdf'
import main from '../assets/png/back.jpg'

export const headerData = {
    name: 'William McCoy',
    title: "Cybersecurity Specialist",
    desciption:"A very diligent and eager person, tackling the world of Cybersecurity. I love to pursue challenging issues and figure out solutions, as this fuels my drive and intrigue.",
    image: main,
    resumePdf: resume
}
